const MarketsLightValues = Object.freeze({
    base: {
        default: '#E7DCF9',
        action: '#B995F3',
        active: '#EDEDED',
        activeAction: '#D9D9D9',
    },
    text: {
        default: '#5A00EE',
        action: '#5A00EE',
        active: '#000000',
        activeAction: '#000000',
    },
});
const MarketsDarkValues = Object.freeze({
    base: {
        default: '#4B2588',
        action: '#854BE2',
        active: '#303030',
        activeAction: '#454545',
    },
    text: {
        default: '#FFFFFF',
        action: '#FFFFFF',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});

export { MarketsDarkValues, MarketsLightValues };
